exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-5970da3a] {\n  -webkit-appearance: auto !important;\n  -moz-appearance: auto !important;\n}", ""]);

// exports
